/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_BalconyInputs */

const cs_form_has_balcony = /** @type {(inputs: Form_Has_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balkon`)
};

const en_form_has_balcony = /** @type {(inputs: Form_Has_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balcony`)
};

/**
* | output |
* | --- |
* | "Balcony" |
*
* @param {Form_Has_BalconyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_balcony = /** @type {((inputs?: Form_Has_BalconyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_BalconyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_balcony(inputs)
	return cs_form_has_balcony(inputs)
});